import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@kambria/kambria-lego';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { connectWallet, transferKAT, transferKYTE } from 'redux/actions/blockchain.action';
import { getKarma } from 'redux/actions/karma.action';
import { getCredits } from 'redux/actions/credit.action';
import RequestWithdrawModal from 'views/components/core/modals/RequestWithdrawModal';
import DepositModal from 'views/components/core/modals/DepositModal';
import Utils from 'helpers/utils';
import { WhatAreTokens, WhatIsCreditModal, WhatIsKarmaModal } from 'views/components/core/modals';
import History from './history';

//For Deposit
// import kamUtil from '@kambria/kambria-util';
import blockchain from 'helpers/blockchain';
import enums from 'helpers/const';
import config from 'config';

const { DEPOSIT_TYPE } = enums;
const { KAT, KYTE } = DEPOSIT_TYPE;
const requiredConfirmationBlocks = 6;

const groupBtnStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: '-5%',
};

const labelPointer = {
  cursor: 'pointer'
};

const panels = (values) => [
  {
    label: 'Your Karma',
    type: 'visibleWhatIsKarmaModal',
    values: [{ value: values.karmas, valueLabel: 'KARMAS', color: 'karma' }],
    url: 'https://kambria.io/ufaqs/what-is-kambria-karma/'
  },
  {
    label: 'Your Credits',
    type: 'visibleWhatIsCreditModal',
    values: [{ value: values.credits, valueLabel: 'CREDITS', color: 'kat' }],
    url: 'https://kambria.io/ufaqs/what-is-kambria-credit/'
  },
  {
    label: 'Your Tokens',
    type: 'visibleWhatAreTokensModal',
    values: [
      { value: values.kats, valueLabel: 'KAT', color: 'kat' },
      { value: values.kytes, valueLabel: 'KYTE', color: 'karma' },
    ],
    actions: [
      { label: 'Widthdraw', type: 'visibleRequestWithdrawModal' },
      { label: 'Deposit', type: 'visibleDepositModal' },
    ],
    url: 'https://kambria.io/ufaqs/what-are-kambria-tokens-for/'
  },
];

class AccountBalance extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visibleWhatIsCreditModal: false,
      visibleWhatIsKarmaModal: false,
      visibleWhatAreTokensModal: false,
      visibleRequestWithdrawModal: false,
      visibleDepositModal: false,
      depositStep: false,
      statusDeposit: 0, // 0: no tx, 1: pending transfer, 2: pending tx, 3: confirmed tx
    };
  }

  componentDidMount() {
    const { getKarmaAmount, getCreditsAmount, user } = this.props;
    getKarmaAmount(user.email);
    getCreditsAmount(user.email);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.blockchain.visible !== nextProps.blockchain.visible && !nextProps.blockchain.visible) {
      if (this.state.depositStep) {
        this.toggleModal('visibleDepositModal')();
        this.setState({ depositStep: false });
      } else {
        this.toggleModal('visibleRequestWithdrawModal')();
      }
    }
  }

  toggleModal =
    (modal) =>
      (visible = false) =>
        this.setState({ [modal]: !this.state[modal] });

  connectWalletInModal = (action = 'request') => {
    switch (action) {
      case 'request':
        this.toggleModal('visibleRequestWithdrawModal')();
        break;
      case 'deposit':
        this.toggleModal('visibleDepositModal')();
        this.setState({ depositStep: true });
        break;
      default:
        break;
    }
    this.props.connectWallet(true);
  };

  transfer = async (value, type) => {
    throw new Error('Not connect wallet yet');
    // const { blockchain, transferKAT, transferKYTE } = this.props;
    // // Change it to your desired receiver address
    // const {
    //   eth: {
    //     RETAILER: { ADDRESS },
    //   },
    // } = config;
    // if (!kamUtil.net.isAddress(blockchain?.account)) {
    //   throw new Error('Not connect wallet yet');
    // }
    // if (!value) {
    //   throw new Error('Invalid amount');
    // }
    // if (![KAT, KYTE].includes(type)) {
    //   throw new Error('Invalid token type');
    // }
    // const transferToken = type === KAT ? transferKAT : transferKYTE;
    // return await transferToken(ADDRESS, kamUtil.unit.kat2WKAT(value));
  };

  onChangeStatusDeposite = (status) => {
    return new Promise((resolve) => {
      this.setState({ statusDeposit: status }, () => resolve());
    });
  };

  onDeposit = async (value, type) => {
    try {
      await this.onChangeStatusDeposite(1);
      const web3 = window.kambriaWallet.provider.web3;
      const txId = await this.transfer(value, type);
      await this.onChangeStatusDeposite(2);
      const ok = await blockchain.countConfirmation(web3, txId, requiredConfirmationBlocks);
      if (!ok) {
        throw new Error('The transaction has been rejected');
      }
      await this.onChangeStatusDeposite(3);
      return txId;
    } catch (er) {
      console.error(er);
      this.setState({ statusDeposit: 0 });
      return null;
    }
  };

  render() {
    const { karma, credit, user } = this.props;
    const KAT_AMOUNT = Math.round(user?.katAmount * 100) / 100;
    const KYTE_AMOUNT = Math.round(user?.kyteAmount * 100) / 100;

    const renderedPanels = panels({
      karmas: Utils.formatNumber(karma.amount, 0, 0),
      credits: Utils.formatNumber(credit.amount, 0, 0),
      kats: Utils.formatNumber(KAT_AMOUNT, 2, 0),
      kytes: Utils.formatNumber(KYTE_AMOUNT, 2, 0),
    });

    return (
      <div className="px-0">
        <h3 className="mt-3 mb-5">Account Balance</h3>
        {renderedPanels.map((panel) => (
          <div key={panel.type} className="balance-wrapper col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 ">
            <p style={labelPointer} className="label">
              <a href={panel.url} target="_blank">{panel.label}</a>
            </p>
            {panel.values.map((v) => (
              <span key={v.valueLabel} className={v.color}>{`${v.value} ${v.valueLabel}`}</span>
            ))}
            {panel?.actions && (
              <div style={groupBtnStyle}>
                {panel.actions.map((btn, i) => (
                  <Button
                    type="primary-gray"
                    size="sm"
                    onClick={this.toggleModal(btn.type)}
                    customStyle={i === panel.actions.length - 1 ? null : { marginRight: '2%' }}
                    key={i}
                  >
                    {btn.label}
                  </Button>
                ))}
              </div>
            )}
          </div>
        ))}
        <History />
        <WhatIsCreditModal
          visibleModal={this.state.visibleWhatIsCreditModal}
          data={this.state}
          closeModal={this.toggleModal('visibleWhatIsCreditModal')}
        />
        <WhatIsKarmaModal
          visibleModal={this.state.visibleWhatIsKarmaModal}
          data={this.state}
          closeModal={this.toggleModal('visibleWhatIsKarmaModal')}
        />
        <WhatAreTokens
          visibleModal={this.state.visibleWhatAreTokensModal}
          data={this.state}
          closeModal={this.toggleModal('visibleWhatAreTokensModal')}
        />
        <RequestWithdrawModal
          visibleModal={this.state.visibleRequestWithdrawModal}
          toggleModal={this.toggleModal('visibleRequestWithdrawModal')}
          connectWallet={this.connectWalletInModal}
        />
        <DepositModal
          visibleModal={this.state.visibleDepositModal}
          toggleModal={this.toggleModal('visibleDepositModal')}
          connectWallet={this.connectWalletInModal}
          onDeposit={this.onDeposit}
          status={this.state.statusDeposit}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ blockchain, user, karma, credit, kWallet }) => ({
  blockchain,
  user,
  karma,
  credit,
});

export default connect(mapStateToProps, {
  getKarmaAmount: getKarma,
  getCreditsAmount: getCredits,
  connectWallet,
  transferKAT,
  transferKYTE,
})(AccountBalance);
